import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <div className="container">
          <div className="navbar-content">
            <Link to="/" className="navbar-brand">
              <img 
                src="/assets/img/logo/hopmate.svg" 
                alt="Hopmate Logo" 
                className="logo"
              />
            </Link>
            <div className="navbar-actions">
              <Link 
                to="/join-as-partner" 
                className={`join-partner-btn ${location.pathname === '/join-as-partner' ? 'active' : ''}`}
              >
                Join as Partner
              </Link>
              <a 
                href="https://play.google.com/store/apps/details?id=com.simpleviralgames.hopmate"
                className="download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download App
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 11V3M8 3L5 6M8 3L11 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;

